import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import TableHeadComponent from '../../shared_components/TableHeadComponent';
import TableBodyRiskClassReductionComponent from './TableBodyRiskClassReductionComponent';
import ShowForceAutoriskClassReductionComponent from './ShowForceAutoriskClassReductionComponent';

@observer
class LoanpartOverviewComponent extends React.Component {
  componentWillReceiveProps() {
    const {
      allMonths,
      allRiskClassReductionMonths,
    } = this.props.CalculationOutputData;

    allMonths();
    allRiskClassReductionMonths();
  }

  render() {
    const dutchColumnNames = [
      'Jaar',
      'Schuldrest',
      'Rente',
      'Rentelast',
      'Aflossing',
      'Maandlast',
    ];

    /* Columnnames are added to determine the order and selection of the row data */
    const columnNames = [
      'year', 'remainingDebt', 'interest', 'gross', 'repayment', 'monthlyPayment',
    ];

    /* Row data is used for each table row, extra row data
    * is only shown for risk class reduction dates
    * */

    const {
      addNumberFormattingByMonth,
      calculationResponseByTotalData,
      allMonthsData,
      allRiskClassReductionMonthData,
      shallowFormDataCopy,
      totalInterestPaymentWithoutForceAutoRiskClassReduction,
    } = this.props.CalculationOutputData;

    const {
      selectedLabelHasAutoRiskClassReduction,
    } = this.props.CalculationFormData;

    const {
      interestPayment,
      repayment,
      redemption,
    } = calculationResponseByTotalData || {};

    const labelHasAutoRiskClassReduction = selectedLabelHasAutoRiskClassReduction();

    return (
      <table className="calculation-container__loanpart-overview">
        <TableHeadComponent
          columnNames={dutchColumnNames}
        />
        <TableBodyRiskClassReductionComponent
          columnNames={columnNames}
          rowData={allMonthsData}
          extraRowData={allRiskClassReductionMonthData}
          addNumberFormattingByMonth={addNumberFormattingByMonth}
        />
        <tfoot>
          <tr>
            <td>Totaal</td>
            {!shallowFormDataCopy.forceAutoRiskClassReduction &&
              <td colSpan={2} />
            }
            <ShowForceAutoriskClassReductionComponent
              selectedLabelHasAutoRiskClassReduction={labelHasAutoRiskClassReduction}
              forceAutoRiskClassReduction={shallowFormDataCopy.forceAutoRiskClassReduction}
              interestPayment={interestPayment}
              totalInterestPaymentWithoutForceAutoRiskClassReduction={
                totalInterestPaymentWithoutForceAutoRiskClassReduction
              }
            />
            <td>{repayment}</td>
            <td>{redemption}</td>
          </tr>
        </tfoot>
      </table>
    );
  }
}

LoanpartOverviewComponent.propTypes = {
  CalculationFormData: PropTypes.shape({
    selectedLabelHasAutoRiskClassReduction: PropTypes.func,
  }),
  CalculationOutputData: PropTypes.shape({
    addNumberFormattingByMonth: PropTypes.func,
    allMonths: PropTypes.func,
    allRiskClassReductionMonths: PropTypes.func,
    allMonthsData: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    calculationResponseByTotalData: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    allRiskClassReductionMonthData: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    totalInterestPaymentWithoutForceAutoRiskClassReduction: PropTypes.number,
    shallowFormDataCopy: PropTypes.shape({}),
  }),
};

LoanpartOverviewComponent.defaultProps = {
  CalculationFormData: {
    selectedLabelHasAutoRiskClassReduction: () => {
    },
  },
  CalculationOutputData: {
    allMonths: () => {},
    allRiskClassReductionMonths: () => {},
    calculationResponseByTotalData: {
      interestPayment: '',
      repayment: '',
      redemption: '',
    },
    allRiskClassReductionMonthData: {},
    allMonthsData: {},
    addNumberFormattingByMonth: () => {},
    totalInterestPaymentWithoutForceAutoRiskClassReduction: 0,
    shallowFormDataCopy: {},
  },
};

export default inject('CalculationOutputData', 'CalculationFormData')(LoanpartOverviewComponent);
